import { Route } from 'react-router-dom'

const PublicRoute = ({ component: Component, redirect = '/login', search = '', ...options }) => {
  const render = props => <Component {...props} {...options} />

  return <Route {...options} render={render} />
}

export default PublicRoute
